export function getActivationHistory(history, publishedActivations) {
  const updatedByVersion = new Map();
  for (const item of history) {
    const key = String(item.version);
    if (item.updated != null && item.updated !== "" && Number.isFinite(new Date(item.updated).getTime()) &&
        (!updatedByVersion.has(key) || new Date(item.updated) > new Date(updatedByVersion.get(key)))) {
      updatedByVersion.set(key, item.updated);
    }
  }
  const withVersionUpdated = item => updatedByVersion.has(String(item.version))
    ? { ...item, updated: updatedByVersion.get(String(item.version)) }
    : item;
  const activeHistory = history.filter(item => item.status === "active").map(withVersionUpdated);
  // Semester preactivations exist before any reports have been created.
  if (publishedActivations === null) return activeHistory;

  const publishedVersions = new Set(publishedActivations.map(item => String(item.version)));
  const lastActivationByVersion = new Map();
  for (const item of activeHistory) {
    const timestamp = item.activated == null || item.activated === "" ? NaN : new Date(item.activated).getTime();
    const key = String(item.version);
    const previous = lastActivationByVersion.get(key);
    if (Number.isFinite(timestamp) && (!previous || timestamp > new Date(previous).getTime())) {
      lastActivationByVersion.set(key, item.activated);
    }
  }
  return [
    ...publishedActivations.map(withVersionUpdated).map(item => {
      // The publishing endpoint exposes the reports' creationDate as activated.
      const fallback = lastActivationByVersion.get(String(item.version));
      if ((item.activated == null || item.activated === "") && fallback != null) {
        return { ...item, activated: fallback, isVersionActivationFallback: true };
      }
      return item;
    }),
    ...activeHistory.filter(item => !publishedVersions.has(String(item.version)))
  ].sort((a, b) => b.version - a.version || new Date(b.activeFrom) - new Date(a.activeFrom));
}

export function groupActivationsByVersionAndYear(activations) {
  const groups = new Map();
  for (const activation of activations) {
    const date = activation.activeFrom == null ? null : new Date(activation.activeFrom);
    const year = date && !Number.isNaN(date.getTime()) ? date.getUTCFullYear() : null;
    const key = JSON.stringify([String(activation.version), year]);
    if (!groups.has(key)) {
      groups.set(key, { version: activation.version, year, activations: [] });
    }
    groups.get(key).activations.push(activation);
    const group = groups.get(key);
    if (activation.updated != null && activation.updated !== "" && Number.isFinite(new Date(activation.updated).getTime()) &&
        (group.updated == null || new Date(activation.updated) > new Date(group.updated))) {
      group.updated = activation.updated;
    }
  }
  return [...groups.values()].sort((a, b) => b.version - a.version || (b.year ?? 0) - (a.year ?? 0));
}
